module.exports = __webpack_public_path__ + "static/media/beach.8f16a17f.jpg";